module.exports = __webpack_public_path__ + "static/images/logo-oxp.63835636a3a84c588dac42ff51addad8.png";